import React, { useState } from 'react';
import { signInWithPopup } from 'firebase/auth';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { auth, googleProvider, db } from '../firebase';
import { useNavigate } from 'react-router-dom';

function Login() {
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleGoogleLogin = async () => {
        try {
            setLoading(true);
            setError('');

            const result = await signInWithPopup(auth, googleProvider);
            const user = result.user;

            // Check if user exists in Firestore
            const userRef = doc(db, 'users', user.uid);
            const userDoc = await getDoc(userRef);

            if (!userDoc.exists()) {
                // New user — create with role 'user', no team yet
                await setDoc(userRef, {
                    name: user.displayName,
                    email: user.email,
                    photoURL: user.photoURL,
                    role: 'user',
                    createdAt: serverTimestamp()
                });

                // Force full reload so onAuthStateChanged reads fresh doc
                window.location.href = '/setup-team';
                return;
            } else {
                const userData = userDoc.data();
                if (userData.teamId) {
                    window.location.href = '/';
                } else {
                    window.location.href = '/setup-team';
                }
                return;
            }
        } catch (err) {
            console.error(err);
            setError('Нэвтрэхэд алдаа гарлаа. Та дахин оролдоно уу.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex-container center-content">
            <div className="glass-card login-card">
                <div className="login-icon">📋</div>
                <h2>Багшийн Туслах</h2>
                <p className="subtitle">Байгууллагын дотоод удирдлагын систем</p>

                {error && <div className="error-message">{error}</div>}

                <button
                    className="btn btn-google"
                    onClick={handleGoogleLogin}
                    disabled={loading}
                >
                    {loading ? (
                        <>
                            <span className="spinner"></span>
                            Нэвтэрч байна...
                        </>
                    ) : (
                        <>
                            <svg className="google-icon" viewBox="0 0 24 24">
                                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" />
                                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
                                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
                                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
                            </svg>
                            Google-ээр нэвтрэх
                        </>
                    )}
                </button>
            </div>
        </div>
    );
}

export default Login;
